import React, { useRef, useState } from "react";
import { MdCloudUpload } from "react-icons/md";
import avatar from "assets/img/avatars/avatar11.png";
import banner from "assets/img/profile/banner.png";
import Card from "components/card";
import api from "services/api";

const R2 = process.env.REACT_APP_R2_PUBLIC_URL || "https://pub-26704679c67f47a28bce53f5dac3f586.r2.dev";

const Banner = ({ session, analytics, onUpdate }) => {
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleAvatarUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    try {
      const key = await api.uploadFile(file, "avatar");
      const res = await api.updateProfile({ avatarUrl: key });
      if (res.success && onUpdate) {
        onUpdate(res.user);
      }
    } catch (error) {
      console.error("Avatar upload failed:", error);
      alert("Failed to upload avatar");
    } finally {
      setUploading(false);
    }
  };

  const currentAvatar = session?.avatarUrl ? `${R2}/${session.avatarUrl}` : avatar;

  return (
    <Card extra={"items-center w-full h-full p-[16px] bg-cover"}>
      {/* Background and profile */}
      <div
        className="relative mt-1 flex h-32 w-full justify-center rounded-xl bg-cover"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div 
          className="absolute -bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full border-[4px] border-white bg-brand-500 dark:!border-navy-700 cursor-pointer group overflow-hidden"
          onClick={() => fileInputRef.current?.click()}
        >
          <img className="h-full w-full rounded-full bg-white object-cover" src={currentAvatar} alt="" />
          <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 transition-opacity group-hover:opacity-100">
            {uploading ? (
              <span className="text-white text-xs font-bold">...</span>
            ) : (
              <MdCloudUpload className="text-white h-6 w-6" />
            )}
          </div>
          <input 
            type="file" 
            ref={fileInputRef} 
            className="hidden" 
            accept="image/*" 
            onChange={handleAvatarUpload} 
          />
        </div>
      </div>

      {/* Name and position */}
      <div className="mt-16 flex flex-col items-center">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          {session?.email?.split('@')[0] || "Admin User"}
        </h4>
        <p className="text-base font-medium text-gray-600">{session?.role || "Administrator"}</p>
        <p className="mt-1 text-sm text-gray-500">{session?.email || ""}</p>
      </div>

      {/* Post followers */}
      <div className="mt-6 mb-3 flex w-full justify-center gap-4 md:!gap-14">
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-navy-700 dark:text-white">
            {analytics?.stats?.movies?.total ?? "-"}
          </p>
          <p className="text-sm font-normal text-gray-600">Movies</p>
        </div>
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-navy-700 dark:text-white">
            {analytics?.stats?.series?.total ?? "-"}
          </p>
          <p className="text-sm font-normal text-gray-600">Series</p>
        </div>
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-navy-700 dark:text-white">
            {analytics?.stats?.users?.total ?? "-"}
          </p>
          <p className="text-sm font-normal text-gray-600">Users</p>
        </div>
      </div>
    </Card>
  );
};

export default Banner;
